import React, { useEffect, useContext } from "react";
import Filter from "../../components/Filter";
import { LocationInfo } from "../../shared/models/Location";
import { MapContext } from "../../containers/Map.context";
import "./Map.scss";
import RefreshButton from "../RefreshButton";
import SearchBox from "../../components/SearchBox";
import SelectedLocationPanel from "../SelectedLocationPanel";
import {
  updateMap,
  changeMapLocations,
  selectLocation
} from "../../containers/Map.action";

const mapOptions: google.maps.MapOptions = require("./options.json");
export type MapInitializeCallbackHandler = () => void;

declare global {
  interface Window {
    initMap: MapInitializeCallbackHandler;
  }
}

interface MapProps {
  locations: Array<LocationInfo>;
}

const Map: React.FC<MapProps> = (props: React.PropsWithChildren<any>) => {
  const { state, dispatch } = useContext(MapContext);

  // Define map callback function
  const initMap: MapInitializeCallbackHandler = () => {
    const map = new google.maps.Map(document.getElementById("map")!, mapOptions);
    const action = updateMap(map);
    dispatch(action);

    const locations = props.locations.map(
      (location: LocationInfo): LocationInfo => {
        const marker = new google.maps.Marker({
          position: location.position,
          map: map,
          clickable: true
        });

        marker.addListener("click", () => {
          map.setCenter(location.position);
          map.setZoom(14);

          const selectAction = selectLocation(location);
          dispatch(selectAction);
        });
        location.marker = marker;
        return location;
      }
    );
    // Adds all locations to map context
    const locationAction = changeMapLocations(locations);
    dispatch(locationAction);
  };

  // Load Maps API effect
  const loadMapsApi = (): void => {
    // Bind map callback function to the window
    window.initMap = initMap;

    let index = window.document.getElementsByTagName("script")[0];
    // Create element
    let script = window.document.createElement("script");
    // Add script content
    script.async = true;
    script.defer = true;
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyA2bmmpiQ2MbiWfLegBchSdzi6oUJYKwsI&callback=initMap";
    // Insert script tag
    if (index.parentNode !== null) {
      index.parentNode.insertBefore(script, index);
    }
  };

  // Use load maps effect
  useEffect(loadMapsApi, []);

  // Render markers on the map and update on props change
  state.locations.map((location: LocationInfo) => {
    if (!state.mapRef || !location.marker) {
      return;
    }
    props.locations.includes(location)
      ? location.marker.setMap(state.mapRef)
      : location.marker.setMap(null);
  });

  return (
    <div id="mapContainer">
      <div id="map" className="mapElement shadow" />
      {state.selectedLocation && (
        <SelectedLocationPanel location={state.selectedLocation} />
      )}
      <SearchBox />
      <Filter />
      <RefreshButton />
    </div>
  );
};

export default Map;
